import { useMediaQuery, Box } from '@mui/material'
import { BrowserRouter } from 'react-router-dom'
import { useTheme } from '@mui/material/styles'
import { createContext } from 'react';
import AppRouter from '../routers/AppRouter'
import MainMenu from './MainMenu'
import Footer from './Footer';

import ServiceModal from './ServiceModal';

export const LayoutContext = createContext({
    isMobile: false
});

const UI = () => {

    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down('sm')) // мобильный экран


    return (
        <>
            <LayoutContext.Provider value={{ isMobile }}>
                <BrowserRouter>
                        <Box
                            display="flex"
                            flexDirection="column"
                            minHeight="100vh"
                        >
                             <ServiceModal />
                            <MainMenu isMobile={isMobile} />
                          
                            <Box
                                display="flex"
                                flexDirection="column"
                                flexGrow={1}
                            >
                                <AppRouter />
                            </Box>
                            <Footer isMobile={isMobile} />
                        </Box>
                   
                </BrowserRouter>
            </LayoutContext.Provider>
        </>
    );
};

export default UI;